import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";
import CardImage from "./Assets/20635 1.png";
import CardIcon5 from "./Assets/accounting.png";
import AppIcon from "./Assets/App Icon-4 (1) (2) 1.png";
import img4 from "./Assets/avatar of young man holding laptop and pointing up.png";
import Stepper2 from "./Assets/Back to school, items for studying.png";
import CardImage5 from "./Assets/banner-design-of-accounting-education-and-financial-literacy-to-improve-economic-growth-illustration-concept-can-be-use-for-landing-page-template-ui-web-mobile-app-poster-banner-website-free-vector 1.png";
import CardIcon2 from "./Assets/candlestick chart.png";
import GoogleButton from "./Assets/DoogleplayButton.png";
import Image from "./Assets/education-tree-concept_1284-10861 1.png";
import FormLogo from "./Assets/FormLogo.png";
import CardIcon4 from "./Assets/globe.png";
import CardIcon from "./Assets/green qr code.png";
import CardImage4 from "./Assets/Group 3.png";
import HeroBg from "./Assets/Hero BG.png";
import Logo from "./Assets/Learncap Logo V1 1.png";
import img5 from "./Assets/mobile credit card and money.png";
import Stepper1 from "./Assets/Mobile login via phone device.png";
import Icon2 from "./Assets/Oil painting of students listening to lecturer.png";
import QRcode from "./Assets/QR code.png";
import Icon from "./Assets/Rocket.png";
import CardIcon3 from "./Assets/roof of the bank building.png";
import Stepper4 from "./Assets/Signing the contract with the stamp.png";
import Steps from "./Assets/Steps.png";
import CardImage2 from "./Assets/Stock trader working on laptop with charts.png";
import img6 from "./Assets/target with dart arrow in bullseye.png";
import img1 from "./Assets/two boys with gadgets.png";
import Image2 from "./Assets/Various training courses for children.png";
import Icon1 from "./Assets/Vector (2).png";
import Visit1 from "./Assets/Visit us 1.png";
import Visit2 from "./Assets/Visit us 2.png";
import Stepper3 from "./Assets/Woman focused on online learning.png";
import CardImage3 from "./Assets/Woman learning a new language online.png";
import img2 from "./Assets/young woman at work with laptop writing.png";
import img3 from "./Assets/young woman studying online.png";
import FormImg from "./Assets/Hand holding a book full of knowledge.png";
import PDFicon from "./Assets/PDFicon.png";
import Footer from "./Component/Footer";
import CircularProgress from "@mui/material/CircularProgress";

const App = () => {
  // const [isOpen, setOpen] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [location, setLocation] = useState("");
  const [error, setError] = useState(false);

  // Handle Submit Function
  const handleSubmit = async (e) => {
    setError(false);

    if (!name || !email || !number || !location) {
      setError(true);
      return;
    }

    let data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("phone_number", number);
    data.append("address", location);

    try {
      // Close dialog
      setSuccess(true);
      await axios.post(
        "https://api.learncap.in/api/contact_us",
        data
      );

      setSuccess(false);
      // Show SweetAlert on success
      Swal.fire({
        icon: "success",
        title: "Form Submitted!",
        text: `Thank you for reaching out to Learncap Academy! Mail has been sent to ${email}.`,
        confirmButtonColor: "#234D20",
      });

      // Reset form fields
      setName("");
      setEmail("");
      setNumber("");
      setLocation("");
    } catch (error) {
      console.error("Error submitting form:", error);
      // Show SweetAlert on error
      setSuccess(false);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Something went wrong. Please try again later.",
        confirmButtonColor: "#C95400",
      });
    }
  };

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={HeroBg}
            sx={{
              width: "100%",
              zIndex: 1,
              position: "absolute",
              height: "120%",
            }}
          />
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Grid
              container
              sx={{
                zIndex: 2,
                position: "relative",
                width: { xs: "100%", md: "80%" },
                margin: "30px 0px",
              }}
              rowGap={2}
            >
              <Grid
                size={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Box
                  component="img"
                  src={Logo}
                  sx={{ width: {
                    xs: "180px",
                    sm: "200px",
                    md: "220px"
                  }, margin: {
                    xs: "10px 0px",
                    sm: "20px 0px",
                    // md: "30px 0px"
                  } }}
                />
              </Grid>
              <Grid
                size={{ xs: 12, lg: 7 }}
                sx={{
                  padding: {
                    xs: "0px 20px",
                    sm: "0px 30px",
                    md: "0px 20px",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: "30px",
                      md: "37px",
                      lg: "48px",
                    },
                    fontWeight: 400,
                    fontFamily: "FigTree",
                    color: "#234D20",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: { xs: "column", md: "row" },
                    flexWrap: "wrap",
                  }}
                >
                  <Box
                    component="img"
                    src={Icon}
                    sx={{ marginRight: "10px", height: "48px", width: "48px" }}
                  />
                  Welcome to Learncap
                </Typography>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "18px",
                      sm: "24px",
                      md: "30px",
                      lg: "36px",
                    },
                    fontWeight: 400,
                    fontFamily: "FigTree",
                    color: "#C95400",
                    textAlign: "center",
                    margin: "15px 0px",
                  }}
                >
                  Unlock Your Potential with Expert-Led, Interactive Courses
                </Typography>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "16px",
                    },
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#757575",
                    textAlign: "center",
                    margin: "10px 0px",
                  }}
                >
                  At Learncap, we believe learning should be more than just a
                  course – it’s an adventure! Whether you’re aiming to boost
                  your career, switch fields, or pick up valuable new skills, we
                  provide dynamic courses designed to make your learning journey
                  fun, practical, and impactful. 🎓✨
                </Typography>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "16px",
                    },
                    fontWeight: 600,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                    textAlign: "center",
                    margin: "10px 0px",
                  }}
                >
                  Join thousands of students who’ve already made Learncap their
                  go-to learning hub. It's time to unlock your future!
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {/* <Button
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "60%",
                      },
                      fontFamily: "Work Sans",
                      fontSize: {
                        xs: "14px",
                        sm: "18px",
                        lg: "20px",
                      },
                      fontWeight: 500,
                      textTransform: "none",
                      color: "#00CE9C",
                      border: "1px solid #00CE9C",
                      borderRadius: "78px",
                      margin: "10px 0px",
                      "&:hover": {
                        backgroundColor: "#00CE9C",
                        color: "#FFFFFF",
                        boxShadow: `
                      0px 1px 2px 0px #4242421A,
                      0px 3px 3px 0px #42424217,
                      0px 7px 4px 0px #4242420D,
                      0px 12px 5px 0px #42424203,
                      0px 18px 5px 0px #42424200
                    `,
                      },
                    }}
                    onClick={() => setOpen(true)}
                  >
                    Contact US
                  </Button> */}
                </Box>
              </Grid>
              <Grid
                size={{ xs: 12, lg: 5 }}
                sx={{
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                  justifyContent: { xs: "center" },
                }}
              >
                <Box
                  component="img"
                  src={Image}
                  sx={{
                    height: {
                      xs: "250px",
                      lg: "400px",
                    },
                    width: {
                      xs: "250px",
                      lg: "400px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box 
        sx={{ marginTop: "150px", display: "flex", width: "100%", padding:"20px 0px", justifyContent:'center' }}
        >
          <Grid container sx={{ width: {xs:'95%',md:'90%',lg:"80%"},boxShadow: "-4px 4px 10px 0px #DADADA40",border:'1px solid #DADADA',borderRadius:'12px',padding:'30px 0px' }} spacing={2}>
            <Grid size={6} sx={{display:{xs:'none',md:'block'}}}>
              <Typography
              sx={{
                fontSize: {
                  xs: "20px",
                  md: "24px",
                },
                fontWeight: 400,
                fontFamily: "FigTree",
                color: "#C95400",
                textAlign:"center"
              }}
               >
              Your Ultimate Learning Adventure!
              </Typography>
              <Box sx={{display:'flex',justifyContent:'center'}}>
                <Box component="img" src={FormImg}/>
              </Box>
              <Typography
              sx={{
                fontSize: {
                  xs: "12px",
                  md: "16px",
                },
                fontWeight: 400,
                fontFamily: "FigTree",
                color: "#757575",
                textAlign:"center"
              }}
              >
              Join thousands of students who’ve already made Learncap their go-to learning hub. It's time to unlock your future! 
              </Typography>
            </Grid>
            <Grid size={{xs:12,md:6}} sx={{padding:{
              xs:'10px 10px',
              md:'10px 20px'
            },display:'flex',justifyContent:'center'}}>
              {/* Form Section */}
              <Box
                component="form"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: {
                    xs:'90%',
                    sm:'70%',
                    md:'100%'
                  }
                }}
              >
                <TextField
                  sx={{ color: "#828282", fontFamily: "Work Sans", "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "green",
                    },
                  }
                }}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonOutlineIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  sx={{ color: "#828282", fontFamily: "Work Sans","& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "green",
                    },
                  }
                }}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter your email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlineIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  sx={{ color: "#828282", fontFamily: "Work Sans","& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "green",
                    },
                  }
                  }}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter your contact number"
                  type="number"
                  value={number}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      setNumber(e.target.value);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CallOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  sx={{ color: "#828282", fontFamily: "Work Sans","& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "green",
                    },
                  }
                }}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter your location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  multiline
                  // rows={2} // Number of rows to show initially
                  maxRows={4} // Maximum number of rows when the user types more
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PlaceOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Error Message */}
                {error && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Work Sans",
                      fontSize: "14px",
                    }}
                  >
                    Please fill out all fields.
                  </Typography>
                )}

                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    backgroundColor: "#234D20",
                    color: "#FFFFFF",
                    borderRadius: "6px",
                    fontFamily: "Work Sans",
                    textTransform: "none",
                    fontSize: "18px",
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            margin: "0px 10px",
            marginTop: "50px",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            size={10}
            sx={{
              width: {
                xs: "100%",
                sm: "90%",
              },
              fontSize: {
                xs: "30px",
                sm: "35px",
                md: "45px",
                lg: "54px",
              },
              fontWeight: 400,
              fontFamily: "FigTree",
              color: "#2E2E2E",
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              marginBottom: "50px",
            }}
          >
            <Box
              component="img"
              src={Image2}
              sx={{
                height: { xs: "200px", md: "286px" },
                width: { xs: "200px", md: "286px" },
              }}
            />
            Popular Courses at Learncap
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            margin: {
              xs: "0px 15px",
              md: "0px 0px",
            },
          }}
        >
          <Grid
            container
            sx={{
              width: { xs: "100%", sm: "90%", md: "80%" },
              padding: "30px 20px",
              border: "1px solid #DADADA",
              borderRadius: "12px",
              transition: "0.3s",
              margin: "50px 0px",
              "&:hover": {
                boxShadow: "-2px 2px 10px 0px #00000040",
              },
            }}
            spacing={2}
            rowGap={3}
          >
            <Grid
              size={{ xs: 12, md: 7 }}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "FigTree",
                  fontWeight: 400,
                  color: "#234D20",
                  display: "flex",
                  alignItems: "center",
                  fontSize: {
                    xs: "30px",
                    sm: "36px",
                  },
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                  textAlign: {
                    xs: "center",
                    sm: "flex-start",
                  },
                }}
              >
                <Box
                  component="img"
                  src={CardIcon}
                  sx={{ height: "36px", width: "36px", marginRight: "10px" }}
                />
                Ethical Hacking
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#2E2E2E",
                  textAlign: "center",
                }}
              >
                Become a Cybersecurity Pro
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Work Sans",
                  color: "#757575",
                  margin: "15px 0px",
                }}
              >
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Outsmart hackers. Protect systems. Be the hero of the
                  digital world
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Learn how to conduct penetration testing and secure
                  networks like a pro
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Dive deep into tools like Wireshark, Metasploit, and more
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Hands-on labs with real-world hacking scenarios to build
                  your skills
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#C95400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={Icon1}
                  sx={{ height: "21px", width: "18.2px", marginRight: "5px" }}
                />
                Course Highlights
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  margin: "20px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  🔍 Ethical Hacking Techniques
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  🔐 Penetration Testing
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  🛠️ Real-World Labs
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  🎯 Placement Guarantee
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={CardImage}
                sx={{
                  height: { xs: "190px", md: "236px" },
                  width: { xs: "268px", md: "328px" },
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              width: { xs: "100%", sm: "90%", md: "80%" },
              padding: "30px 20px",
              border: "1px solid #DADADA",
              borderRadius: "12px",
              transition: "0.3s",
              margin: "50px 0px",
              "&:hover": {
                boxShadow: "-2px 2px 10px 0px #00000040",
              },
            }}
            spacing={2}
            rowGap={3}
          >
            <Grid
              size={{ xs: 12, md: 7 }}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "FigTree",
                  fontWeight: 400,
                  color: "#234D20",
                  display: "flex",
                  alignItems: "center",
                  fontSize: {
                    xs: "30px",
                    sm: "36px",
                  },
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                  textAlign: {
                    xs: "center",
                    sm: "flex-start",
                  },
                }}
              >
                <Box
                  component="img"
                  src={CardIcon2}
                  sx={{ height: "36px", width: "36px", marginRight: "10px" }}
                />
                Stock Trading
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#2E2E2E",
                }}
              >
                Master the Markets
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Work Sans",
                  color: "#757575",
                  margin: "15px 0px",
                }}
              >
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Unlock the secrets to successful trading and smart
                  investments
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Master both the art and science of stock trading
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉Learn technical & fundamental analysis to make winning
                  trades
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Create personalized trading strategies that align with your
                  financial goals
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Simulate real-time market trading with live market
                  simulations
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#C95400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={Icon1}
                  sx={{ height: "21px", width: "18.2px", marginRight: "5px" }}
                />
                Course Highlights
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  margin: "20px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  💹 Trading Basics
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📊 Risk Management
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📅 Real-Time Simulations
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={CardImage2}
                sx={{
                  height: { xs: "196px", md: "236px" },
                  width: { xs: "248px", md: "308px" },
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              width: { xs: "100%", sm: "90%", md: "80%" },
              padding: "30px 20px",
              border: "1px solid #DADADA",
              borderRadius: "12px",
              transition: "0.3s",
              margin: "50px 0px",
              "&:hover": {
                boxShadow: "-2px 2px 10px 0px #00000040",
              },
            }}
            spacing={2}
            rowGap={3}
          >
            <Grid
              size={{ xs: 12, md: 7 }}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "FigTree",
                  fontWeight: 400,
                  color: "#234D20",
                  display: "flex",
                  alignItems: "center",
                  fontSize: {
                    xs: "30px",
                    sm: "36px",
                  },
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                  textAlign: {
                    xs: "center",
                    sm: "flex-start",
                  },
                }}
              >
                <Box
                  component="img"
                  src={CardIcon3}
                  sx={{ height: "36px", width: "40px", marginRight: "10px" }}
                />
                IBPS Bank PO Exam
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#2E2E2E",
                  textAlign: "center",
                }}
              >
                Your Gateway to a Successful Banking Career
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Work Sans",
                  color: "#757575",
                  margin: "15px 0px",
                }}
              >
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Unlock the secrets to successful trading and smart
                  investments
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Ace the most competitive banking exam with top-notch
                  preparation
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Master Quantitative Aptitude, Reasoning, English, and
                  General Awareness
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Create personalized trading strategies that align with your
                  financial goals
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Get exam tips, time-saving techniques, and access to mock
                  tests
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#C95400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={Icon1}
                  sx={{ height: "21px", width: "18.2px", marginRight: "5px" }}
                />
                Course Highlights
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  margin: "20px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📖 Expert Study Materials
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  🧠 Exam Strategies
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📝 Practice Tests
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={CardImage3}
                sx={{
                  height: { xs: "196px", md: "236px" },
                  width: { xs: "248px", md: "308px" },
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              width: { xs: "100%", sm: "90%", md: "80%" },
              padding: "30px 20px",
              border: "1px solid #DADADA",
              borderRadius: "12px",
              transition: "0.3s",
              margin: "50px 0px",
              "&:hover": {
                boxShadow: "-2px 2px 10px 0px #00000040",
              },
            }}
            spacing={2}
            rowGap={3}
          >
            <Grid
              size={{ xs: 12, md: 7 }}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "FigTree",
                  fontWeight: 400,
                  color: "#234D20",
                  display: "flex",
                  alignItems: "center",
                  fontSize: {
                    xs: "30px",
                    sm: "36px",
                  },
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                  textAlign: {
                    xs: "center",
                    sm: "flex-start",
                  },
                }}
              >
                <Box
                  component="img"
                  src={CardIcon4}
                  sx={{ height: "40px", width: "40px", marginRight: "10px" }}
                />
                Digital Marketing
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#2E2E2E",
                }}
              >
                Create, Grow, Succeed
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Work Sans",
                  color: "#757575",
                  margin: "15px 0px",
                }}
              >
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Unlock the secrets to successful trading and smart
                  investments
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Ace the most competitive banking exam with top-notch
                  preparation
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Master Quantitative Aptitude, Reasoning, English, and
                  General Awareness
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Create personalized trading strategies that align with your
                  financial goals
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Get exam tips, time-saving techniques, and access to mock
                  tests
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#C95400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={Icon1}
                  sx={{ height: "21px", width: "18.2px", marginRight: "5px" }}
                />
                Course Highlights
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  margin: "20px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📖 Expert Study Materials
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  🧠 Exam Strategies
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📝 Practice Tests
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={CardImage4}
                sx={{
                  height: { xs: "196px", md: "236px" },
                  width: { xs: "248px", md: "308px" },
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              width: { xs: "100%", sm: "90%", md: "80%" },
              padding: "30px 20px",
              border: "1px solid #DADADA",
              borderRadius: "12px",
              transition: "0.3s",
              margin: "50px 0px",
              "&:hover": {
                boxShadow: "-2px 2px 10px 0px #00000040",
              },
            }}
            spacing={2}
            rowGap={3}
          >
            <Grid
              size={{ xs: 12, md: 7 }}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "FigTree",
                  fontWeight: 400,
                  color: "#234D20",
                  display: "flex",
                  alignItems: "center",
                  fontSize: {
                    xs: "30px",
                    sm: "36px",
                  },
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                  textAlign: {
                    xs: "center",
                    sm: "flex-start",
                  },
                }}
              >
                <Box
                  component="img"
                  src={CardIcon5}
                  sx={{ height: "40px", width: "40px", marginRight: "10px" }}
                />
                Accounting
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#2E2E2E",
                  textAlign: "center",
                }}
              >
                The Power of Financial Management
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Work Sans",
                  color: "#757575",
                  margin: "15px 0px",
                }}
              >
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Take control of your finances and become a financial expert
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Learn how to manage financial statements, reports, and
                  budgets with ease
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Understand bookkeeping, financial reporting, and accounting
                  software
                </Typography>
                <Typography style={{ margin: "5px 0px" }}>
                  👉 Gain real-world skills to kickstart your career in finance
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Work Sans",
                  color: "#C95400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={Icon1}
                  sx={{ height: "21px", width: "18.2px", marginRight: "5px" }}
                />
                Course Highlights
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  margin: "20px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  📊 Bookkeeping
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  💸 Financial Analysis
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#2E2E2E",
                  }}
                >
                  💻 Accounting Tools
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={CardImage5}
                sx={{
                  height: { xs: "196px", md: "236px" },
                  width: { xs: "248px", md: "308px" },
                }}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Typography
            sx={{
              width: "100%",
              fontSize: {
                xs: "25px",
                sm: "30px",
                md: "45px",
                lg: "54px",
              },
              fontWeight: 400,
              fontFamily: "FigTree",
              color: "#2E2E2E",
              textAlign: "center",
              margin: "50px 0px",
            }}
          >
            Why Choose Learncap?
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              margin: "0px 0px",
            }}
          >
            <Grid
              container
              sx={{
                width: "70%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              spacing={4}
            >
              <Grid
                size={3}
                sx={{ minHeight: "300px", width: "223px", padding: "10px" }}
              >
                <Box component="img" src={img1} sx={{}} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#2E2E2E",
                    }}
                  >
                    Expert-Led Courses
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#757575",
                    }}
                  >
                    Industry experts with years of real-world experience guide
                    you every step of the way.
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={3}
                sx={{ minHeight: "300px", width: "223px", padding: "10px" }}
              >
                <Box component="img" src={img2} sx={{}} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#2E2E2E",
                    }}
                  >
                    Hands-On Learning
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#757575",
                    }}
                  >
                    Engage in interactive assignments, live simulations, and
                    real projects that bring your lessons to life.
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={3}
                sx={{ minHeight: "300px", width: "223px", padding: "10px" }}
              >
                <Box component="img" src={img3} sx={{}} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#2E2E2E",
                    }}
                  >
                    Learn Anytime, Anywhere
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#757575",
                    }}
                  >
                    Take your courses on the go! Learn from your phone, tablet,
                    or laptop – whenever, wherever
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={3}
                sx={{ minHeight: "300px", width: "223px", padding: "10px" }}
              >
                <Box component="img" src={img4} sx={{}} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#2E2E2E",
                    }}
                  >
                    Job-Ready Skills
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#757575",
                    }}
                  >
                    Our courses focus on practical, in-demand skills so you can
                    apply what you learn directly to your job
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={3}
                sx={{ minHeight: "300px", width: "223px", padding: "10px" }}
              >
                <Box component="img" src={img5} sx={{}} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#2E2E2E",
                    }}
                  >
                    Affordable & Accessible
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#757575",
                    }}
                  >
                    Our courses focus on practical, in-demand skills so you can
                    apply what you learn directly to your job
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={3}
                sx={{ minHeight: "300px", width: "223px", padding: "10px" }}
              >
                <Box component="img" src={img6} sx={{}} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#2E2E2E",
                    }}
                  >
                    Placement Guarantee
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#757575",
                    }}
                  >
                    Top courses with Placement Guarantee to help you land your
                    dream job in tech, banking, and more
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            margin: "100px 0px",
          }}
        >
          <Grid
            container
            sx={{
              width: {
                xs: "100%",
                sm: "80%",
                md: "90%",
                lg: "80%",
                xl: "70%",
              },
              padding: {
                xs: "10px",
                md: "0px",
              },
            }}
            rowGap={2}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  width: {
                    xs: "100%",
                    sm: "90%",
                  },
                  fontSize: {
                    xs: "27px",
                    md: "30px",
                    lg: "36px",
                  },
                  fontWeight: 400,
                  fontFamily: "FigTree",
                  color: "#2E2E2E",
                  display: "flex",
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "#229083",
                  marginBottom: "20px",
                }}
              >
                <Box
                  component="img"
                  src={AppIcon}
                  sx={{
                    height: "40px",
                    width: "40px",
                  }}
                />
                MarketGreeks
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "18px",
                  fontWeight: 500,
                  color: "#2E2E2E",
                  textAlign: "center",
                }}
              >
                Take control of your share market investments with our
                comprehensive portfolio management app
              </Typography>
              <Box
                component="a"
                href="https://play.google.com/store/apps/details?id=com.app.marketgreek&pcampaignid=web_share&pli=1"
                target="_blank" // Opens the link in a new tab
                rel="noopener noreferrer"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
                <Box
                  component="img"
                  src={GoogleButton}
                  sx={{
                    height: "52px",
                    width: "180px",
                    margin: "20px 0px",
                    "&:hover": {
                      boxShadow: "-2px 2px 10px 0px #00000040",
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={QRcode}
                  sx={{
                    height: { xs: "180px", sm: "203px", md: "263px" },
                    width: { xs: "180px", sm: "203px", md: "263px" },
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: 500,
                    fontSize: "18px",
                    fontFamily: "Work Sans",
                    color: "#757575",
                  }}
                >
                  To download, scan this code with your phone
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box> */}

        <Box sx={{ padding: "0px 10px", marginTop: "70px" }}>
          <Box
            sx={{
              marginBottom: "0px",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                width: {
                  xs: "100%",
                  sm: "90%",
                },
                fontSize: {
                  xs: "35px",
                  md: "45px",
                  lg: "54px",
                },
                fontWeight: 400,
                fontFamily: "FigTree",
                color: "#2E2E2E",
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Box
                component="img"
                src={Icon2}
                sx={{
                  height: "133px",
                  width: "165px",
                }}
              />
              How Learncap Works
            </Typography>
          </Box>

          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              width: "100%",
              justifyContent: "center",
              margin: "50px 0px",
            }}
          >
            <Box component="img" src={Steps} />
          </Box>
          <Box
            sx={{
              width: "100%",
              display: { xs: "flex", lg: "none" },
              justifyContent: "center",
              margin: "30px 0px",
            }}
          >
            <Grid
              container
              rowSpacing={5}
              sx={{
                width: {
                  xs: "100%",
                  md: "80%",
                  lg: "70%",
                },
              }}
            >
              <Grid
                size={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                }}
              >
                <Box
                  component="img"
                  src={Stepper1}
                  sx={{
                    width: {
                      xs: "178.57px",
                      sm: "257.14px",
                    },
                    height: {
                      xs: "185.09px",
                      sm: "270.18px",
                    },
                    margin: "10px",
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "28px",
                        sm: "32px",
                      },
                      fontWeight: 600,
                      fontFamily: "Work Sans",
                      color: "#2E2E2E",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Sign Up
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "15px",
                        sm: "18px",
                      },
                      fontWeight: 500,
                      fontFamily: "Work Sans",
                      color: "#626262",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Get started in just a few clicks! Registration is quick,
                    simple, and free! 🌐
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: {
                    xs: "column-reverse",
                    sm: "row",
                  },
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "28px",
                        sm: "32px",
                      },
                      fontWeight: 600,
                      fontFamily: "Work Sans",
                      color: "#2E2E2E",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Pick Your Course
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "15px",
                        sm: "18px",
                      },
                      fontWeight: 500,
                      fontFamily: "Work Sans",
                      color: "#626262",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Browse through our dynamic, expert-designed courses and pick
                    the one that aligns with your goals. 🎯
                  </Typography>
                </Box>
                <Box
                  component="img"
                  src={Stepper2}
                  sx={{
                    width: {
                      xs: "208.55px",
                      sm: "290.14px",
                    },
                    height: {
                      xs: "135.09px",
                      sm: "190.18px",
                    },
                    margin: "10px",
                  }}
                />
              </Grid>
              <Grid
                size={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },
                }}
              >
                <Box
                  component="img"
                  src={Stepper3}
                  sx={{
                    width: {
                      xs: "208.57px",
                      sm: "307.14px",
                    },
                    height: {
                      xs: "155.09px",
                      sm: "270.18px",
                    },
                    margin: "10px",
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "28px",
                        sm: "32px",
                      },
                      fontWeight: 600,
                      fontFamily: "Work Sans",
                      color: "#2E2E2E",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Start Learning
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "15px",
                        sm: "18px",
                      },
                      fontWeight: 500,
                      fontFamily: "Work Sans",
                      color: "#626262",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Dive into interactive lessons, fun quizzes, and real-world
                    projects. Get hands-on learning from day one! 💪
                  </Typography>
                </Box>
              </Grid>
              <Grid
                size={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: {
                    xs: "column-reverse",
                    sm: "row",
                  },
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "28px",
                        sm: "32px",
                      },
                      fontWeight: 600,
                      fontFamily: "Work Sans",
                      color: "#2E2E2E",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Get Certified
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "15px",
                        sm: "18px",
                      },
                      fontWeight: 500,
                      fontFamily: "Work Sans",
                      color: "#626262",
                      textAlign: {
                        xs: "center",
                        sm: "left",
                      },
                    }}
                  >
                    Complete your course and receive an official Learncap
                    Certificate to showcase your expertise and skills. 🎓
                  </Typography>
                </Box>
                <Box
                  component="img"
                  src={Stepper4}
                  sx={{
                    width: {
                      xs: "178.55px",
                      sm: "257.14px",
                    },
                    height: {
                      xs: "185.09px",
                      sm: "270.18px",
                    },
                    margin: "10px",
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box sx={{ margin: "100px 0px 20px 0px" }}>
          <Typography
            sx={{
              textAlign: "center",
              fontFamily: "Work Sans",
              fontSize: "36px",
              fontWeight: 600,
            }}
          >
            What Our Students Are Saying
          </Typography>
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                width: {
                  xs: "100%",
                  sm: "90%",
                  md: "60%",
                  lg: "75%",
                },
                padding: "10px",
                margin: "30px 0px",
              }}
            >
              <Grid size={{ xs: 12, lg: 6 }}>
                <Box
                  sx={{
                    padding: "20px",
                    border: "0.5px solid #D8D8D8",
                    borderRadius: "4px",
                    minHeight: "200px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      alt="Amit Sharma"
                      src="/static/images/avatar/1.jpg"
                      sx={{
                        marginRight: "10px",
                        height: "65px",
                        width: "65px",
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontSize: "24px",
                          fontWeight: 500,
                          color: "#2E2E2E",
                        }}
                      >
                        Amit Sharma
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontSize: "16px",
                          fontWeight: 500,
                          color: "#828282",
                        }}
                      >
                        Ethical Hacking Graduate
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#2E2E2E",
                      margin: "10px 0px",
                    }}
                  >
                    Learncap’s Ethical Hacking course was a game-changer! I
                    started as a complete beginner, and now I’m certified and
                    working as a cybersecurity professional! The hands-on labs
                    and support from instructors were amazing!
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, lg: 6 }}>
                <Box
                  sx={{
                    padding: "20px",
                    border: "0.5px solid #D8D8D8",
                    borderRadius: "4px",
                    minHeight: "200px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      alt="Priya Kapoor"
                      src="/static/images/avatar/1.jpg"
                      sx={{
                        marginRight: "10px",
                        height: "65px",
                        width: "65px",
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontSize: "24px",
                          fontWeight: 500,
                          color: "#2E2E2E",
                        }}
                      >
                        Priya Kapoor
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontSize: "16px",
                          fontWeight: 500,
                          color: "#828282",
                        }}
                      >
                        Stock Trading Graduate
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#2E2E2E",
                      margin: "10px 0px",
                    }}
                  >
                    Thanks to Learncap’s Stock Trading course, I’ve gained the
                    confidence to trade effectively and make smarter investment
                    decisions. It was broken down so simply – highly recommend!
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            margin: {
              xs: "20px",
              md: "50px",
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "34px",
                md: "37px",
                lg: "48px",
              },
              fontWeight: 400,
              fontFamily: "FigTree",
              color: "#234D20",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: { xs: "column", md: "row" },
              flexWrap: "wrap",
            }}
          >
            <Box
              component="img"
              src={Icon}
              sx={{ marginRight: "10px", height: "48px", width: "48px" }}
            />
            Ready to Level Up?
          </Typography>
          <Typography
            sx={{
              color: "#C95400",
              fontFamily: "Work Sans",
              fontSize: "20px",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Get Started Today! 🌟
          </Typography>
          <Typography
            sx={{
              color: "#757575",
              fontFamily: "Work Sans",
              fontSize: "16px",
              fontWeight: 500,
              textAlign: "center",
              width: {
                xs: "100%",
                md: "90%",
                lg: "50%",
              },
            }}
          >
            Don’t wait for the perfect moment. The time to upgrade your skills
            and unlock endless opportunities is NOW! Whether you want to become
            an Ethical Hacker, a Stock Trading Expert, a Digital Marketing Guru,
            or a Financial Master, Learncap has everything you need to succeed
          </Typography>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0px",
                gap: 3,
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="img"
                  src={Visit1}
                  sx={{
                    marginRight: "10px",
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      color: "#2E2E2E",
                      fontFamily: "Work Sans",
                      fontSize: "20px",
                      fontWeight: 600,
                    }}
                  >
                    Visit us at
                  </Typography>
                  <a href="/" target="_top" rel="noopener noreferrer">
                    www.Learncap.in
                  </a>
                </Box>
              </Box>
              {/* <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="img"
                  src={Visit2}
                  sx={{
                    marginRight: "10px",
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      color: "#2E2E2E",
                      fontFamily: "Work Sans",
                      fontSize: "20px",
                      fontWeight: 600,
                    }}
                  >
                    Visit us at
                  </Typography>
                  <a
                    href="mailto:sachin.k.kumar@Learncap.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    sachin.k.kumar@Learncap.in
                  </a>
                </Box>
              </Box> */}
            </Box>
          </Box>
        </Box>

        <Footer />
      </Box>

      {/* Loader */}
      {isSuccess && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            position: "fixed",
            top: 0,
            zIndex: 2,
            background: "rgba(0, 0, 0, 0.7)",
          }}
        >
          <CircularProgress sx={{ color: "#00CE9C" }} size="5rem" />
        </Box>
      )}
    </>
  );
};

export default App;
